module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-flex-clounm m-sec-detail",
    staticStyle: {
      "margin-top": "93px",
      "padding-top": "0px"
    }
  }, [_c('h3', {
    staticClass: "m-form-title"
  }, [_vm._v("选择顾问")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "select-agent"
  }, [_c('div', [_c('div', {
    staticClass: "province-and-city"
  }, [_c('div', {
    staticClass: "province-content flex-center"
  }, [_c('div', {
    staticClass: "province-title"
  }, [_vm._v("选择省份")]), _vm._v(" "), _c('div', {
    staticClass: "select-province"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agentPro),
      expression: "agentPro"
    }],
    staticClass: "input-pro",
    attrs: {
      "placeholder": "请选择省份",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.agentPro)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showProInfo.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.agentPro = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "collpose-img",
    attrs: {
      "src": require("../../assets/images/open-province.png")
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProDiv),
      expression: "showProDiv"
    }],
    staticClass: "flex-row select-pro-div",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "select-pro-title"
  }, [_vm._v("省份选择：")]), _vm._v(" "), _c('table', [_vm._l((_vm.areaData), function(item, index) {
    return [(index % 3 === 0) ? _c('tr', {
      key: index,
      attrs: {
        "align": "left"
      }
    }, [_c('td', [_c('div', {
      class: [
        'td-cell',
        {
          active: _vm.agentPro == item.province,
        } ],
      on: {
        "click": function($event) {
          return _vm.selectProvince(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.province) + "\n                      ")])]), _vm._v(" "), _c('td', [(index + 1 < _vm.areaData.length) ? _c('div', {
      class: [
        'td-cell',
        {
          active: _vm.agentPro == _vm.areaData[index + 1].province,
        } ],
      on: {
        "click": function($event) {
          return _vm.selectProvince(_vm.areaData[index + 1])
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.areaData[index + 1].province) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', [(index + 2 < _vm.areaData.length) ? _c('div', {
      class: [
        'td-cell',
        {
          active: _vm.agentPro == _vm.areaData[index + 2].province,
        } ],
      on: {
        "click": function($event) {
          return _vm.selectProvince(_vm.areaData[index + 2])
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.areaData[index + 2].province) + "\n                      ")]) : _vm._e()])]) : _vm._e()]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "city-content flex-row"
  }, [_c('div', {
    staticStyle: {
      "flex-shrink": "0",
      "margin-top": "1px"
    }
  }, [_vm._v("选择地区")]), _vm._v(" "), _c('div', {
    staticClass: "city-content-inner"
  }, _vm._l((_vm.cityData), function(cityObj, index) {
    return _c('div', {
      key: cityObj.id,
      class: [
        'city-item',
        {
          'current-city-item': _vm.agentCity == cityObj.name
        } ],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectCity(cityObj)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(cityObj.name || "全部"))])])
  }), 0)])]), _vm._v(" "), (_vm.agentData && _vm.agentData.length > 0) ? _c('div', {
    staticClass: "agent-list"
  }, [_vm._l((_vm.agentData), function(agent, index) {
    return [_c('div', {
      key: index,
      staticClass: "broker-item",
      class: {
        'broker-active': _vm.agentId == agent.id
      },
      on: {
        "click": function($event) {
          return _vm.getAgentId(agent.id, agent.idCard, agent.type)
        }
      }
    }, [(_vm.agentId == agent.id) ? _c('img', {
      staticClass: "check-icon",
      attrs: {
        "src": require("../../assets/icons/checked.png")
      }
    }) : _c('img', {
      staticClass: "check-icon",
      attrs: {
        "src": require("../../assets/icons/un_check.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "broker-avator"
    }, [_c('avatar', {
      attrs: {
        "width": "48",
        "url": _vm._f("imgcrop")(agent.avator, 48, 48),
        "star": agent.star
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "broker-info"
    }, [_c('div', {
      staticClass: "broker-name"
    }, [_vm._v("\n                " + _vm._s(agent.name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "broker-city"
    }, [_vm._v(_vm._s(agent.cityName))])])])]
  })], 2) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("暂无顾问")])]), _vm._v(" "), _c('div', {
    staticClass: "m-form-input",
    staticStyle: {
      "width": "346px",
      "margin-top": "24px"
    }
  }, [_c('div', {
    staticClass: "m-error",
    staticStyle: {
      "width": "100%",
      "top": "-30px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorInfo) + "\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "m-all-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.nextClick
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8e4bdf8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/agent/select-agent.vue
// module id = 655
// module chunks = 1